module.exports = __webpack_public_path__ + "static/media/pic.88a8b97e.webp";